// extracted by css-extract-rspack-plugin
export default {"resizing":"l2PtY","tabsPanel":"bsgX2","sidebarResizableBox":"s6Thw"};